module.exports = __webpack_public_path__ + "static/media/img_13.fafe7b31.png";